export enum NutritionLabelDownloadFileFormat {
  Pdf,
  png
}